<template>
<svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.2 1.5H12.8L14.2 3.5H17C18.1046 3.5 19 4.39543 19 5.5V14.5C19 15.6046 18.1046 16.5 17 16.5H3C1.89543 16.5 1 15.6046 1 14.5V5.5C1 4.39543 1.89543 3.5 3 3.5H5.8L7.2 1.5Z" stroke="white" stroke-linejoin="round"/>
<path d="M6.5 10C6.5 8.067 8.067 6.5 10 6.5C11.0937 6.5 12.0703 7.00166 12.7121 7.78738" stroke="white" stroke-linecap="round"/>
<path d="M13.5 10C13.5 11.933 11.933 13.5 10 13.5C8.90633 13.5 7.92969 12.9983 7.28789 12.2126" stroke="white" stroke-linecap="round"/>
<path d="M12.9 5.9V7.9H10.9" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.1 14.1V12.1H9.1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>

<script>
export default {
  name: 'IconCameraSwitch'
}
</script>
